module.exports = __webpack_public_path__ + "img/header-project.6dd5c63e.png";